"use client";

// Modal.js
import useModal from "@/functions/useModal";
import { useCallback, useEffect } from "react";
import { twMerge } from "tailwind-merge";

function ContainerModal({ children, className }) {
  const { isModalOpen, closeModal } = useModal();

  // useEffect(() => {
  //   if (isModalOpen) {
  //     history.pushState(null, null, location.href);
  //     history.back();
  //     history.forward();
  //     window.onpopstate = function () {
  //       // closeModal();
  //       history.forward();
  //     };
  //   } else {
  //     window.onpopstate = null;
  //   }
  // }, [isModalOpen]);

  return (
    isModalOpen && (
      <div
        className='fixed inset-0 flex items-center justify-center bg-shadesGON-100 bg-opacity-50'
        onClick={closeModal}
        style={{
          zIndex:100
        }}
        >
        <div
          onClick={(e) => e.stopPropagation()}
          className={twMerge(
            "bg-white w-full max-h-screen max-w-7xl px-gon py-gon rounded shadow-lg overflow-hidden overflow-y-scroll",
            className
          )}>
          {children}
        </div>
      </div>
    )
  );
}

export default ContainerModal;
